module.exports = __webpack_public_path__ + "static/media/parttern.687cf616.png";